import { Appliance } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useApplianceDetails(id: string) {
  const url = `/v2/orm/appliances/${id}`;
  const request = new Request(url);

  return useAuthenticatedRequest<Appliance>(request, {
    queryKey: ['admin-appliance', { id }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useApplianceDetails;
